const config = {
  backendUrl: "/data-service/",
};
export default config;
